import React, { memo } from "react";

import { IsNullUndefinedEmpty } from "../../../utils/helper";
import OrderBump from "../../Shared/OrderBump";

const OrderBumpComponent = memo(
  ({ step, orderBumps, data, actionHandler, customStyle, isMobileSize }) => {
    if (IsNullUndefinedEmpty(orderBumps)) return <></>;

    return orderBumps.map((orderBump) => (
      <div key={orderBump.product.product_id}>
        <OrderBump
          isMobileSize={isMobileSize}
          step={step}
          orderBump={orderBump}
          data={data}
          actionHandler={actionHandler}
          customStyle={customStyle}
        />
      </div>
    ));
  },
  (prevProps, nextProps) => {
    return prevProps.data === nextProps.data;
  }
);

const OrderBumps = memo(
  ({ productData, data, actionHandler, step, customStyle, isMobileSize }) => {
    return (
      <OrderBumpComponent
        isMobileSize={isMobileSize}
        orderBumps={productData.bumps}
        data={data}
        step={step}
        actionHandler={actionHandler}
        customStyle={customStyle}
      />
    );
  },
  (prevProps, nextProps) => {
    return prevProps.data?.purchase_products?.length === nextProps.data?.purchase_products?.length;
  }
);

export default OrderBumps;
